const HEX_SHORTHAND_LENGTH = 3
const HEX_FULL_LENGTH = 6

/**
 * Normalise a CSS hex colour to 6 digits. Vuetify hands back the SCSS value
 * verbatim, so theme colours arrive as shorthand ("#fff"), while Capacitor's
 * toolbarColor expects a full hex string.
 *
 * @returns {string|null} lowercase "#rrggbb", or null if not a hex colour.
 */
export function expandHexColor(hex) {
  const raw = typeof hex === 'string' ? hex.trim().toLowerCase() : ''
  if (!raw.startsWith('#')) return null

  const digits = raw.slice(1)
  if (!/^[0-9a-f]+$/.test(digits)) return null

  if (digits.length === HEX_FULL_LENGTH) return `#${digits}`
  if (digits.length === HEX_SHORTHAND_LENGTH) {
    return `#${digits.split('').map(d => d + d).join('')}`
  }
  return null
}

/**
 * Normalise a hex colour typed or pasted by a user. Brand guidelines quote
 * colours both ways ("#7A1F3D" and "7A1F3D"), so the leading hash is optional
 * here -- everything else is delegated to expandHexColor.
 *
 * @returns {string|null} lowercase "#rrggbb", or null if not a hex colour.
 */
export function parseHexInput(value) {
  const raw = typeof value === 'string' ? value.trim() : ''
  if (!raw) return null

  return expandHexColor(raw.startsWith('#') ? raw : `#${raw}`)
}
